
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/sales-scripts",
      function () {
        return require("private-next-pages/site/sales-scripts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/sales-scripts"])
      });
    }
  